import { useId, useMemo, useState } from 'react';
import css from './page-events.module.scss';
import { EventListItem } from 'src/types/events';
import CustomPageBlock, { PageBlockProps } from '../page-block';
import Item from 'src/pages/events/list/item';
import ServicePaginationCard from 'src/pages/services/cards/service-pagination-card';
import { EVENTS } from 'src/constants/routes';

export default function CustomPageEvents({ items, title, description, type }: Readonly<PageBlockProps<EventListItem>>) {
  const cardId = useId();
  const [itemsToShow, setItemsToShow] = useState(5);

  const hidePaginationCard = items.length <= itemsToShow;

  const slisedItems = useMemo(() => items.slice(0, itemsToShow), [items, itemsToShow]);

  if (slisedItems.length === 0) return null;

  return (
    <CustomPageBlock title={title} description={description} type={type} path={EVENTS.path}>
      <div className={css.cards}>
        {slisedItems.map((event) => (
          <Item
            key={`${event.id}-${crypto.randomUUID()}`}
            event={{ ...event, slug: `${EVENTS.relativePath}/${event.slug}` }}
          />
        ))}
        {!hidePaginationCard && <ServicePaginationCard key={cardId} onClick={() => setItemsToShow(items.length)} />}
      </div>
    </CustomPageBlock>
  );
}
